import { z } from "zod";

const envSchema = z.object({
  VITE_API_ENDPOINT_DEV: z.string().optional(),
  VITE_API_ENDPOINT_TEST: z.string().optional(),
  VITE_API_ENDPOINT_STAGING: z.string().optional(),
  VITE_API_ENDPOINT_PROD: z.string().optional(),

  VITE_APPSIGNAL_DEV_API_KEY: z.string().optional(),
  VITE_APPSIGNAL_TEST_API_KEY: z.string().optional(),
  VITE_APPSIGNAL_STAGING_API_KEY: z.string().optional(),
  VITE_APPSIGNAL_PROD_API_KEY: z.string().optional(),

  VITE_MATOMO_URL_DEV: z.string().optional(),
  VITE_MATOMO_URL_TEST: z.string().optional(),
  VITE_MATOMO_URL_STAGING: z.string().optional(),
  VITE_MATOMO_URL_PROD: z.string().optional(),
  VITE_MATOMO_SITE_ID_DEV: z.string().optional(),
  VITE_MATOMO_SITE_ID_TEST: z.string().optional(),
  VITE_MATOMO_SITE_ID_STAGING: z.string().optional(),
  VITE_MATOMO_SITE_ID_PROD: z.string().optional(),
});

export const envVars = envSchema.parse(import.meta.env);
